import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
  markDefault,
} from "FormBuilderAction";
import { DEVELOPMENT_TYPE, COMMON_FAIL_MESSAGE } from "Constants";
import TicketAssocLink from "./ticket-assoc-link";
import LocaleStrings from "Languages";

class FormList extends Component {
  constructor(props) {
    super(props);
  }

  editForm(item) {
    // console.log("item :- ", item);
    let formNameEdit = item.formname;
    let newObj = JSON.parse(item.formjson);
    let formtype = item.formtype;
    let fixedObj = [];

    if (formtype === "checkout") {
      fixedObj = [
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Email",
          name: "email",
          id: "email",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "First Name",
          name: "firstname",
          id: "firstname",
          header: "Input",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: false,
          maxlen: "250",
          label: "Last Name",
          name: "lastname",
          id: "lastname",
          header: "Input",
        },
        // {
        //   key: "interestcheckboxes",
        //   defaultfields: "fixed",
        //   required: false,
        //   label: "Interest",
        //   name: "interest",
        //   id: "interest",
        //   header: "Multi Select",
        //   options: [
        //     { value: "software", text: "Software" },
        //     { value: "automation", text: "Automation" },
        //     { value: "gaming", text: "Gaming" },
        //     { value: "it", text: "IT" },
        //   ],
        // },
      ];
    } else if (formtype === "exhibitor") {
      fixedObj = [
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Banner",
          name: "banner",
          id: "banner",
          header: "File",
          note: "(Recommended size: 566px * 368px)",
        },
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Logo",
          name: "logo",
          id: "logo",
          header: "File",
          note: "(Recommended size: 400px *220px)",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: true,
          maxlen: "250",
          label: "Exhibitor/Company Name",
          name: "name",
          id: "name",
          header: "Input",
        },
        {
          key: "textarea",
          defaultfields: "fixed",
          required: false,
          maxlen: "1000",
          label: "About/Bio",
          name: "about",
          id: "about",
          header: "Textarea",
        },
      ];
    } else if (formtype === "sponsor") {
      fixedObj = [
        {
          key: "dropdown",
          defaultfields: "fixed",
          required: false,
          label: "Category",
          name: "category",
          id: "category",
          hasCondition: false,
          header: "Dropdown",
          options: [
            { value: "1", text: "Platinum", displayfields: "" },
            { value: "2", text: "Gold", displayfields: "" },
            { value: "3", text: "Silver", displayfields: "" },
            { value: "4", text: "Bronze", displayfields: "" },
          ],
        },
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Banner",
          name: "banner",
          id: "banner",
          header: "File",
          note: "(Recommended size: 1147px * 368px)",
        },
        {
          key: "file",
          defaultfields: "fixed",
          filetype: "image",
          required: false,
          maxupload: "1",
          label: "Upload Logo",
          name: "logo",
          id: "logo",
          header: "File",
          note: "(Recommended size: 350px * 200px)",
        },
        {
          key: "textinput",
          defaultfields: "fixed",
          required: true,
          maxlen: "250",
          label: "Sponsor/Company Name",
          name: "name",
          id: "name",
          header: "Input",
        },
        {
          key: "textarea",
          defaultfields: "fixed",
          required: false,
          maxlen: "1000",
          label: "About/Bio",
          name: "about",
          id: "about",
          header: "Textarea",
        },
      ];
    }

    this.props.dynamicFormModal({
      key: "edit",
      showModal: true,
      category: formtype,
      fixedFields: fixedObj,
      formDetails: item,
    });
    this.props.updateFomeName(formNameEdit); // Form Name
    this.props.updateFormList(newObj, this.props.oldKeys, "samearray"); // Updating redux with editing from json
    this.props.formEdited(false); // This is used for edit form
  }

  handleDefault = (item) => {
    let { session, pagination, currentPage } = this.props;

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.checkout_default_update_title}</h1>
            <p>{LocaleStrings.checkout_default_update_subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.props.markDefault(
                    session,
                    { formid: item.formid },
                    (response) => {
                      onClose();
                      if (response.success === 1) {
                        this.props.showSuccess(
                          LocaleStrings.checkout_default_update_success
                        );
                        pagination(currentPage);
                      } else {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  render() {
    let { formList } = this.props;

    return (
      <tr>
        {/* <td>
          <div className="vcenter">{formList.formnumber}</div>
        </td> */}
        <td>
          <div className="">{formList.formname}</div>
          <div className="custom-text1-theme-normal">
            {formList.isdefault == 1 ? `(${LocaleStrings.default})` : ""}
          </div>
        </td>
        {/* <td>
          <div className="vcenter">{formList.versionno}</div>
        </td> */}
        <td>
          <div className="vcenter text-capitalize">{formList.formtype}</div>
          <div
            className="custom-text1-theme-normal text-decoration-underline pointer"
            onClick={() => this.handleDefault(formList)}
          >
            {formList.isdefault == 1 ? "" : `(${LocaleStrings.set_default})`}
          </div>
        </td>
        <td>
          <div style={{ display: "flex" }}>
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <div
                style={{
                  paddingBottom: "5px",
                  paddingRight: "8px",
                  textAlign: "center",
                }}
              >
                <TicketAssocLink formDetails={formList} />
              </div>
            )}
            <div
              id="checkoutform-edit-restyle"
              style={{ paddingBottom: "5px", textAlign: "center" }}
            >
              <button
                type="button"
                className="btn btn-custom-table-blue"
                onClick={() => this.editForm(formList)}
              >
                <i className="fa fa-pencil i-custom-ms"></i>
                {/* <img className="i-custom-normal i-custom-m" src="../../style/images/custom-icons/edit.svg" /> */}
                {LocaleStrings.button_edit}
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    oldKeys: state.formList,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
  markDefault,
})(FormList);
